module.exports = require('./dist/lib/universal');
